import { render, staticRenderFns } from "./DisabledCard.vue?vue&type=template&id=5ebabd32&"
import script from "./DisabledCard.vue?vue&type=script&lang=ts&"
export * from "./DisabledCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports